import { Routes } from '@angular/router';

export const developmentRoutes: Routes = [
	{
		path: 'dev',
		loadChildren: () => import('../pages/dev/dev.module').then(m => m.DevPagesModule)
	}
];
